import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {ActionResponse, Volume, VolumeRequest} from 'typings/portaro.be.types';
import type {AnyObject} from 'typings/portaro.fe.types';

/**
 * @ngdoc service
 * @name volumeDataService
 * @module portaro.data-services
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing volumes of documents
 */
export class VolumeDataService {
    public static serviceName = 'volumeDataService';

    private static readonly VOLUMES_ROUTE = 'volumes';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async query(filterParam: AnyObject): Promise<Volume[]> {
        return this.Restangular
                   .all(VolumeDataService.VOLUMES_ROUTE)
                   .getList(filterParam);
    }

    @ngAsync()
    @unRestangularize()
    public async get(volumeId: string): Promise<Volume> {
        return this.Restangular
                   .one(VolumeDataService.VOLUMES_ROUTE, volumeId)
                   .get<Volume>();
    }

    @ngAsync()
    @unRestangularize()
    public async save(volumeRequest: VolumeRequest): Promise<ActionResponse> {
        return this.Restangular
                   .all(VolumeDataService.VOLUMES_ROUTE)
                   .post(transferify(volumeRequest));
    }

    @ngAsync()
    public async edit(volumeId: number): Promise<ActionResponse> {
        return this.Restangular
                   .all(VolumeDataService.VOLUMES_ROUTE)
                   .one(String(volumeId))
                   .one('form')
                   .get();
    }
}
